<template>
    <b-button
        @click="() => { modalState = true }"
        size="sm"
        :disabled="disabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        block
    ><!-- button -->
        <span v-if="httpRequestInProgress">
            <b-spinner
                type="grow"
                label="Loading..."
                small
            />
            </span>
        <span v-else>Storno <span v-if="authorization.dev">[REFUND: 3]</span></span>
        <b-modal
            v-model="modalState"
            id="modal-unfreeze-order"
            title="Erstatten"
            size="md"
            @hidden="() => { this.modalState = false }"
        ><!-- modal -->
            <!-- @ok="submit()"
            cancel-title="abbrechen" -->
            Diese Bestellung wirklich erstatten?
            <div slot="modal-footer" class="w-100">
               <b-btn
                  centered
                  size="md"
                  class="float-right mx-1"
                  variant="danger"
                  @click="submit()"
               >Erstatten</b-btn>
               <b-btn size="md" class="float-right" variant="secondary" @click="() => { this.modalState = false }">Abbrechen</b-btn>
            </div>
        </b-modal>


    </b-button>
</template>
<script>
    export default {
        props: ['customerOrder', 'orderStates', 'authorization']
        ,data() {
            return {
                modalState: false
              , httpRequestInProgress: false
              , unrefundableMarketIds: [ 12, 17, 25, 26, 27, 28 ] // marketplaces which do not allow refunding stuff // FNAC, Cdiscount, RueDuCommerce, Worten, FNAC PT, FNAC BE
            }
        }
        ,computed: {
            disabled: function() 
            {
                // if we are not in WAIT or OPEN, disable button.
                //if([this.orderStates.codes.WAIT, this.orderStates.codes.OPEN].includes(this.customerOrder.orderState)) return true;

                if(this.unrefundableMarketIds.includes(this.customerOrder.marketAccount.marketId)) return true;

                if(this.customerOrder.isMarketplaceMultiorder) return true;

                let delivery_submitted_to_marketplace = false;
                for (let history of this.customerOrder.customerorderhistories) {
                  if (history.lastUpdateReason.includes("Delivery Job")) {
                    delivery_submitted_to_marketplace = true;
                    break;
                  }
                }

                //Button is enabled if: (State is WAIT or OPEN) AND NOT delivery_submitted_to_marketplace
                // ([this.orderStates.codes.WAIT, this.orderStates.codes.OPEN].includes(this.customerOrder.orderState) && !delivery_submitted_to_marketplace)
                // --> Invert this for disabled property

                return !([this.orderStates.codes.WAIT, this.orderStates.codes.OPEN].includes(this.customerOrder.orderState) && !delivery_submitted_to_marketplace);
            }
        }
        , methods: {
            submit() {
                const payload = {
                    orderState: this.orderStates.codes.REFUND,
                    customerOrderId: this.customerOrder.id
                }
                this.httpRequestInProgress = true;
                this.modalState = false;
                // guarantees a minium delay of 750ms or longer, if request takes longer. The animation looks very consistent thereby.
                //NICE very cool trick, gotta remember this one
                Promise.all([
                    axios.post('/customerorder/action/refund', payload), // TODO url and logic
                    new Promise(r => setTimeout(r, 750))
                ]).then( () => {
                    // let clone = _.deepClone(this.customerOrder);
                    // clone.orderState = this.orderStates.codes.WAIT;
                    this.$emit('mutatedOrderState', this.orderStates.codes.REFUND);
                    this.httpRequestInProgress = false;
                }).catch( error => {
                    alert("Konnte Bestellung nicht erstatten.");
                    console.error(error);
                });

            }


        }
    }
</script>
